// Application mutations.
export const APP_IS_LOADING = 'APP_IS_LOADING'

// User mutations.
export const SET_AUTHORIZED = 'SET_AUTHORIZED'
export const SET_AUTHORIZED_PROPERTY = 'SET_AUTHORIZED_PROPERTY'
export const SET_USER = 'SET_USER'
export const SET_USER_PROPERTY = 'SET_USER_PROPERTY'

export const SET_BI_DATA = 'SET_BI_DATA'
export const SET_BI_METRICS = 'SET_BI_METRICS'
export const SET_BI_ANNUAL = 'SET_BI_ANNUAL'

// Tag Mutations.
export const SET_TAG = 'SET_TAG'
export const SET_TAGS = 'SET_TAGS'
export const SET_TAGS_PAGINATION = 'SET_TAGS_PAGINATION'
export const REPLACE_TAGS = 'REPLACE_TAGS'
export const RESET_TAGS = 'RESET_TAGS'
export const SET_TAGS_PAGINATION_PROPERTY = 'SET_TAGS_PAGINATION_PROPERTY'
export const REMOVE_TAG = 'REMOVE_TAG'
export const ADD_TAG = 'ADD_TAG'
export const SET_TAG_TALENT_PAGINATION = 'SET_TAG_TALENT_PAGINATION'
export const SET_TAG_TALENT_PAGINATION_PROPERTY = 'SET_TAG_TALENT_PAGINATION_PROPERTY'

// Location Mutations
export const SET_LOCATIONS = 'SET_LOCATIONS'
export const SET_LOCATION_SUBURBS = 'SET_LOCATION_SUBURBS'
export const SET_LOCATION_SUBURBS_PAGINATION = 'SET_LOCATION_SUBURBS_PAGINATION'

// Opportunity Mutations
export const SET_OPPORTUNITIES = 'SET_OPPORTUNITIES'

// Category Mutations
export const SET_CATEGORIES = 'SET_CATEGORIES'

// Payment Detail Mutations
export const SET_PAYMENT_DETAILS = 'SET_PAYMENT_DETAILS'
export const SET_PAYMENT_DETAILS_PROPERTY = 'SET_PAYMENT_DETAILS_PROPERTY'
export const RESET_PAYMENT_DETAILS = 'RESET_PAYMENT_DETAILS'

// Endorsements Mutations
export const SET_ENDORSEMENTS = 'SET_ENDORSEMENTS'
export const SET_ENDORSEMENT_PROPERTY = 'SET_ENDORSEMENT_PROPERTY'
export const ADD_ENDORSEMENT = 'ADD_ENDORSEMENT'
export const REMOVE_ENDORSEMENT = 'REMOVE_ENDORSEMENT'

// Talent
export const SET_TALENT = 'SET_TALENT'
export const SET_SPONSORS = 'SET_SPONSORS'
export const SET_ARTICLES = 'SET_ARTICLES'
export const SET_CHARITIES = 'SET_CHARITIES'

// Additional Talent Mutations
export const ADD_ADDITIONAL_TALENT = 'ADD_ADDITIONAL_TALENT'
export const REMOVE_ADDITIONAL_TALENT = 'REMOVE_ADDITIONAL_TALENT'
export const RESET_ADDITIONAL_TALENT = 'RESET_ADDITIONAL_TALENT'

// Request Mutations
export const RESET_REQUEST = 'RESET_REQUEST'
export const SET_REQUEST = 'SET_REQUEST'
export const SET_RECOMMENDATIONS = 'SET_RECOMMENDATIONS'
export const SET_RECOMMENDATIONS_PAGINATION = 'SET_RECOMMENDATIONS_PAGINATION'
export const SET_REQUESTS = 'SET_REQUESTS'
export const SET_REQUESTS_PAGINATION = 'SET_REQUESTS_PAGINATION'
export const SET_REQUEST_PROPERTY = 'SET_REQUEST_PROPERTY'
export const ADD_REQUESTS = 'ADD_REQUESTS'
export const REPLACE_REQUEST_TALENT = 'REPLACE_REQUEST_TALENT'
export const REMOVE_REQUEST_TALENT = 'REMOVE_REQUEST_TALENT'
export const SET_REQUEST_TALENT_PROPERTY = 'SET_REQUEST_TALENT_PROPERTY'
export const SET_FORM_STATUS = 'SET_FORM_STATUS'
export const SET_FORM_DIRTY = 'SET_FORM_DIRTY'

// Vetting Requests Mutations
export const SET_VETTING_REQUESTS = 'SET_VETTING_REQUESTS'
export const SET_VETTING_PAGINATION = 'SET_VETTING_PAGINATION'
export const ADD_VETTING_REQUESTS = 'ADD_VETTING_REQUESTS'
export const SET_VETTING_REQUEST = 'SET_VETTING_REQUEST'
export const RESET_VETTING_REQUEST = 'RESET_VETTING_REQUEST'
export const SET_VETTING_REQUEST_PROPERTY = 'SET_VETTING_REQUEST_PROPERTY'
export const REMOVE_VETTING_REQUEST_TALENT = 'REMOVE_VETTING_REQUEST_TALENT'

// Booking Mutations
export const SET_BOOKING = 'SET_BOOKING'
export const SET_BOOKINGS = 'SET_BOOKINGS'
export const SET_BOOKINGS_PAGINATION = 'SET_BOOKINGS_PAGINATION'
export const ADD_BOOKINGS = 'ADD_BOOKINGS'
export const REPLACE_BOOKING_TALENT = 'REPLACE_BOOKING_TALENT'
export const SET_BOOKING_PROPERTY = 'SET_BOOKING_PROPERTY'
export const SET_BOOKING_HISTORY = 'SET_BOOKING_HISTORY'
export const REMOVE_BOOKING_TALENT = 'REMOVE_BOOKING_TALENT'
export const ADD_MESSAGE_BOOKING = 'ADD_MESSAGE_BOOKING'
export const BOOKING_THREAD_UNREAD_COUNT = 'BOOKING_THREAD_UNREAD_COUNT'

export const SET_PAYMENT = 'SET_PAYMENT'

// Booking Notes Mutations
export const SET_NOTES = 'SET_NOTES'
export const SET_NOTE = 'SET_NOTE'
export const UNPIN_ALL_NOTES = 'UNPIN_ALL_NOTES'
export const ADD_NOTE = 'ADD_NOTE'
export const REMOVE_NOTE = 'REMOVE_NOTE'

export const SET_FILES = 'SET_FILES'
export const SET_FILE = 'SET_FILE'
export const ADD_FILE = 'ADD_FILE'
export const REMOVE_FILE = 'REMOVE_FILE'
export const CLEAR_FILES = 'CLEAR_FILES'
export const SET_FILES_LOADING = 'SET_FILES_LOADING'

// Booking Source Mutations
export const SET_SOURCE = 'SET_SOURCE'
export const SET_FIRST_SOURCE = 'SET_FIRST_SOURCE'

// Payment Mutations
export const SET_PAYMENT_CLIENT_TOKEN = 'SET_PAYMENT_CLIENT_TOKEN'
export const SET_PAYMENTS = 'SET_PAYMENTS'
export const ADD_PAYMENTS = 'ADD_PAYMENTS'
export const SET_PAYMENTS_PAGINATION = 'SET_PAYMENTS_PAGINATION'
export const SET_PAYMENT_LIST_PAYMENT = 'SET_PAYMENT_LIST_PAYMENT'

// Talent Mutations
export const ADD_TAG_TALENTS = 'ADD_TAG_TALENTS'
export const SET_TAG_TALENT = 'SET_TAG_TALENT'
export const SET_TAG_TALENT_LIST = 'SET_TAG_TALENT_LIST'
export const SET_TALENTS = 'SET_TALENTS'
export const SET_TALENTS_COUNTS = 'SET_TALENTS_COUNTS'
export const ADD_TALENTS = 'ADD_TALENTS'
export const RESET_TALENTS = 'RESET_TALENTS'
export const SET_TALENTS_PAGINATION = 'SET_TALENTS_PAGINATION'

// Admin Mutations
export const SET_ADMINS = 'SET_ADMINS'
export const SET_ADMINS_COUNTS = 'SET_ADMINS_COUNTS'
export const ADD_ADMINS = 'ADD_ADMINS'
export const RESET_ADMINS = 'RESET_ADMINS'
export const SET_ADMINS_PAGINATION = 'SET_ADMINS_PAGINATION'
export const REMOVE_ADMIN = 'REMOVE_ADMIN'

export const SET_INTERNS = 'SET_INTERNS'
export const SET_INTERNS_COUNTS = 'SET_INTERNS_COUNTS'
export const SET_INTERNS_PAGINATION = 'SET_INTERNS_PAGINATION'
export const ADD_INTERNS = 'ADD_INTERNS'
export const RESET_INTERNS = 'RESET_INTERNS'
export const REMOVE_INTERN = 'REMOVE_INTERN'

// Client Mutations
export const SET_CLIENT = 'SET_CLIENT'
export const SET_CLIENTS = 'SET_CLIENTS'
export const SET_CLIENTS_COUNTS = 'SET_CLIENTS_COUNTS'
export const SET_CLIENTS_COMPANIES = 'SET CLIENTS COMPANIES'
export const ADD_CLIENTS = 'ADD_CLIENTS'
export const RESET_CLIENTS = 'RESET_CLIENTS'
export const SET_CLIENTS_PAGINATION = 'SET_CLIENTS_PAGINATION'
export const RESET_CLIENT = 'RESET_CLIENT'

// Manager Mutations
export const SET_MANAGER = 'SET_MANAGER'
export const SET_MANAGERS = 'SET_MANAGERS'
export const SET_MANAGERS_COUNTS = 'SET_MANAGERS_COUNTS'
export const ADD_MANAGERS = 'ADD_MANAGERS'
export const RESET_MANAGERS = 'RESET_MANAGERS'
export const SET_MANAGERS_PAGINATION = 'SET_MANAGERS_PAGINATION'
export const RESET_MANAGER = 'RESET_MANAGER'

// Billboard Mutations
export const SET_BILLBOARD_FILTER = 'SET_BILLBOARD_FILTER'
export const RESET_BILLBOARD_FILTERS = 'RESET_BILLBOARD_FILTERS'

// Settings
export const SET_SETTINGS = 'SET_SETTINGS'
export const SET_SETTINGS_PROPERTY = 'SET_SETTINGS_PROPERTY'

// Dashboard Mutations
export const SET_WIDGETS = 'SET_WIDGETS'
export const SET_DASHBOARD_LISTS = 'SET_DASHBOARD_LISTS'
export const ADD_MESSAGE_DASHBOARD = 'ADD_MESSAGE_DASHBOARD'
export const DASHBOARD_THREAD_UNREAD_COUNT = 'DASHBOARD_THREAD_UNREAD_COUNT'

// Filter Mutations
export const SET_FILTER = 'SET_FILTER'
export const RESET_FILTERS = 'RESET_FILTERS'

// Manager Staff User Mutations
export const SET_MANAGER_STAFF_USERS = 'SET_MANAGER_STAFF_USERS'
export const SET_MANAGER_STAFF_USER = 'SET_MANAGER_STAFF_USER'
export const ADD_MANAGER_STAFF_USER = 'ADD_MANAGER_STAFF_USER'
export const SET_MANAGER_STAFF_USER_PROPERTY = 'SET_MANAGER_STAFF_USER_PROPERTY'
export const REPLACE_MANAGER_STAFF_USER = 'REPLACE_MANAGER_STAFF_USER'
export const SET_CLUB_EMAIL = 'SET_CLUB_EMAIL'

// Calendar Mutations
export const SET_CALENDAR_BOOKINGS = 'SET_CALENDAR_BOOKINGS'

// Custom Notifications Mutations
export const SET_STEP = 'SET_STEP'
export const SET_USERS = 'SET_USERS'
export const ADD_USERS = 'ADD_USERS'
export const REMOVE_USER = 'REMOVE_USER'
export const ADD_ACTION_BTN = 'ADD_ACTION_BTN'
export const REMOVE_ACTION_BTN = 'REMOVE_ACTION_BTN'
export const SET_NOTIFICATION_DATA_PROPERTY = 'SET_NOTIFICATION_DATA_PROPERTY'
export const SET_TAG_DATA_PROPERTY = 'SET_TAG_DATA_PROPERTY'
export const RESET_DATA_PROPERTY = 'RESET_DATA_PROPERTY'

// CustomNotification Notifications Mutations
export const SET_CUSTOM_NOTIFICATION = 'SET_CUSTOM_NOTIFICATION'
export const SET_CUSTOM_NOTIFICATIONS = 'SET_CUSTOM_NOTIFICATIONS'
export const SET_CUSTOM_NOTIFICATIONS_PAGINATION = 'SET_CUSTOM_NOTIFICATIONS_PAGINATION'
export const ADD_CUSTOM_NOTIFICATIONS = 'ADD_CUSTOM_NOTIFICATIONS'

// Messaging Mutations
export const SET_THREAD = 'SET_THREAD'
export const SET_THREADS = 'SET_THREADS'
export const SET_THREAD_PROPERTY = 'SET_THREAD_PROPERTY'
export const SET_THREADS_THREAD = 'SET_THREADS_THREAD'
export const SET_UNREAD_COUNT = 'SET_UNREAD_COUNT'
export const ADD_MESSAGE = 'ADD_MESSAGE'
export const SET_MESSAGE = 'SET_MESSAGE'
export const SET_MESSAGE_BY_ID = 'SET_MESSAGE_BY_ID'
export const REMOVE_MESSAGE = 'REMOVE_MESSAGE'
export const ADD_THREADS = 'ADD_THREADS'
export const SET_THREADS_PAGINATION = 'SET_THREADS_PAGINATION'
export const INCREMENT_UNREAD_COUNT = 'INCREMENT_UNREAD_COUNT'
export const SET_THREAD_FILTER = 'SET_THREAD_FILTER'
export const RESET_THREAD_FILTERS = 'RESET_THREAD_FILTERS'
export const SET_THREAD_PARTICIPANT_READ = 'SET_THREAD_PARTICIPANT_READ'
export const SET_TYPING = 'SET_TYPING'
export const SET_SENDING = 'SET_SENDING'
export const CLEAR_THREAD = 'CLEAR_THREAD'

// Notifications Mutations
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS'
export const SET_NOTIFICATION_UNREAD_COUNT = 'SET_NOTIFICATION_UNREAD_COUNT'
export const SET_NOTIFICATIONS_PAGINATION = 'SET_NOTIFICATIONS_PAGINATION'
export const ADD_NOTIFICATIONS = 'ADD_NOTIFICATIONS'
export const SET_NOTIFICATION_PROPERTY = 'SET_NOTIFICATION_PROPERTY'

export const SET_OPTED_IN = 'SET_OPTED_IN'

export const SET_PACKAGES = 'SET_PACKAGES'

export const SET_VETTING_COUNT = 'SET_VETTING_COUNT'

export const SET_REGIONS = 'SET_REGIONS'

export const SET_CONTRACTS = 'SET_CONTRACTS'

export const ADD_TAG_TALENT = 'ADD_TAG_TALENT'
export const REMOVE_TAG_TALENT = 'REMOVE_TAG_TALENT'

export const SET_TAG_TALENT_PROPERTY = 'SET_TAG_TALENT_PROPERTY'

export const SET_USER_FILTER = 'SET_USER_FILTER'
export const RESET_USER_FILTERS = 'RESET_USER_FILTERS'

export const SET_TAG_PROPERTY = 'SET_TAG_PROPERTY'

export const SET_DEPARTMENTS = 'SET_DEPARTMENTS'
export const ADD_DEPARTMENTS = 'ADD_DEPARTMENTS'

export const SET_USER_PROFILE_PROPERTY = 'SET_USER_PROFILE_PROPERTY'

export const SET_TAG_TYPES = 'SET_TAG_TYPES'
export const UPDATE_SYNONYMS = 'UPDATE_SYNONYMS'
export const UPDATE_TRANSLATIONS = 'UPDATE_TRANSLATIONS'

export const SET_TALENT_OPPORTUNITY_BUDGET = 'SET_TALENT_OPPORTUNITY_BUDGET'
